// @flow

import React from "react";
import type { ResultItemContainerProps } from "../../../utils/_types";
import CategorizationSlot from "../ItemSlots/CategorizationSlot";
import ImageSlot from "../ItemSlots/ImageSlot";
import { shape, string } from "prop-types";
import { format } from "date-fns";

const DefaultItem = ({ result, translations }: ResultItemContainerProps) => {
  const { title, "@id": url, effective, description, image } = result;
  const effectiveDate = effective
    ? format(new Date(effective), "dd/MM/yyyy")
    : "";
  const keepReadingLabel = translations
    ? translations.keep_reading_label
    : "Keep reading";

  return (
    <div className="result-item">
      <ImageSlot image={image} />
      <div className="data">
        {effectiveDate ? (
          <div className="info">
            <div className="date">
              <i className="fas fa-calendar-alt" /> {effectiveDate}
            </div>
          </div>
        ) : (
          ""
        )}
        <h3>{title}</h3>
        {description && description.length ? (
          <p className="description">{description}</p>
        ) : (
          ""
        )}
        <p className="keep-reading">
          <a href={url} title={keepReadingLabel}>
            {keepReadingLabel} <i className="fas fa-angle-right" />
          </a>
        </p>
      </div>
    </div>
  );
};

DefaultItem.propTypes = {
  result: shape({
    title: string,
    "@id": string,
    effective: string,
    description: string,
    image: ImageSlot.propTypes.image,
    subjects: CategorizationSlot.propTypes.subjects,
    UID: string,
  }).isRequired,
  translations: shape({ keepReadingLabel: string }),
};

export default DefaultItem;
